var m = "云视频";
import carLocate from "@/components/locate/carLocate";
import allLocate from "@/components/locate/allLocate";
import locus from "@/components/locus/";
import locusPeson from "@/components/locusPeson/";
import carVideo from "@/components/video/carVideo";
import byVideo from "@/components/video/byVideo";
import carVideoHistory from "@/components/video/carVideoHistory";
import byCarVideoHistory from "@/components/video/byCarVideoHistory";
import oil from "../../node_modules/common/src/components/oil/oil";
import temp from "../../node_modules/common/src/components/temp/";
var data = [
  {
    path: "/oil",
    component: oil
  },
  {
    path: "/temp",
    component: temp
  },
  {
    path: "/locus",
    component: locus
  },
  {
    path: "/locusPeson",
    component: locusPeson
  },
  {
    path: "/carVideo",
    component: m == "云视频" ? byVideo : carVideo
  }, {
    path: "/carVideoHistory",
    component: m == "云视频" ? byCarVideoHistory : carVideoHistory
  },
  {
    path: "/carLocate",
    component: carLocate
  },
  {
    path: "/carLocate1",
    component: allLocate
  },
];
export default data;



// WEBPACK FOOTER //
// ./src/router/locate.js